import { render } from "./FieldEditor.vue?vue&type=template&id=7fa4089e&scoped=true"
import script from "./FieldEditor.vue?vue&type=script&lang=js"
export * from "./FieldEditor.vue?vue&type=script&lang=js"

import "./FieldEditor.vue?vue&type=style&index=0&id=7fa4089e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fa4089e"]])

export default __exports__